import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import TableWrapper from "@/components/Table/TableWrapper";
import statementHistorySchema from "@/components/Table/schemas/statement_history";

const recentTransactionsSchema = statementHistorySchema.map((col) =>
  col.id === "narration" ? { ...col, truncate: true } : col
);
import { getStatementEntries } from "@/services/loanservices";

export default function RecentTransactions({ loanUUID }) {
  const [transactions, setTransactions] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!loanUUID) return;
    fetchTransactions();
  }, [loanUUID]);

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const res = await getStatementEntries(loanUUID, "desc");
      const rows = res?.results?.rows || [];
      setTransactions(rows.slice(0, 4));
    } catch (err) {
      console.error("Failed to fetch transactions", err);
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleViewAll = () => {
    navigate(`/lms/${loanUUID}/transactions`);
  };

  return (
    <div className="bg-white rounded-lg p-4">
      <Row className="align-items-center">
        <Col xs={8} className="text-md fw-semibold text-gray-500">
          Recent Transactions
        </Col>
        <Col xs={4} className="text-end">
          <span
            className="text-sm text-decoration-underline cursor-pointer"
            onClick={handleViewAll}
          >
            View All
          </span>
        </Col>
      </Row>

      <div className="mt-3">
        <TableWrapper
          columnSchema={recentTransactionsSchema}
          tableData={transactions || []}
          isLoading={loading}
        />

        {!loading && transactions?.length === 0 && (
          <div className="text-center py-4 text-muted">
            <div className="fw-semibold">No transactions available</div>
          </div>
        )}
      </div>

    </div>
  );
}
